import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const archivedPlansRoute: InvariantJiraRoute = {
	name: 'archived-plans-directory',
	path: '/jira/plans/settings/archive',
	exact: true,
};
